import { h, Fragment } from 'preact';
import { useProduct } from './product-context';

const ProductTitle = () => {
  const { activeProduct } = useProduct();
  return (
    <>
      <h1 className="text-h5 uppercase leading-[29px] mb-[5px] font-normal yeoo">
        {activeProduct.title.split(':')[0]}
      </h1>
      {activeProduct?.productSubtitle ? (
        <div className="text-text-2 text-[14px] leading-[22px] mb-[2px]">
          {activeProduct?.productSubtitle?.value}
        </div>
      ) : null}
    </>
  );
};

export default ProductTitle;
